<div class="flex flex-column">
	<div class="item"><b>Nome:</b> {{ user.name }}</div>
	<div class="item"><b>Cidade:</b> {{ user.location }}</div>
	<div class="item sent_date">
		Lista enviada em {{ user.sent | date: 'dd/MM/yyyy' }}
	</div>
	<div class="table">
		<p-table [value]="user.list" styleClass="p-datatable-striped">
			<ng-template pTemplate="header">
				<tr>
					<th pSortableColumn="name">
						Nome <p-sortIcon field="name" />
					</th>
					<th pSortableColumn="points" style="width:20%">
						Pontos <p-sortIcon field="points" />
					</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-item>
				<tr  *ngIf="item.points > 0">
					<td>
						<a class="death-link" (click)="nav.goDeadView(item.death_id, item.name)">{{ item.name }}</a>
					</td>
					<td *ngIf="item.points > 0">
						<i class="fa fa-trophy"></i>
						{{ item.points }} pontos
					</td>
				</tr>
				<tr *ngIf="item.points == 0">
					<td>{{ item.name }}</td>
					<td>
						-
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>